import React, { useState, useEffect } from "react";
import imageError from '../error.jpg'
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Error404 = ({
  strings = ["صفحه موردنظر یافت نشد"],
  typeSpeed = 100,
  backSpeed = 50,
  backDelay = 1000,
  loop = false,
  showCursor = true,
  cursorChar = "|"
}) => {
  const navigate = useNavigate()
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!strings.length) return;

    const timeout = setTimeout(() => {
      if (isDeleting) {
        if (charIndex > 0) {
          setText((prev) => prev.slice(0, -1));
          setCharIndex((prev) => prev - 1);
        } else {
          setIsDeleting(false);
          setIndex((prev) => (prev + 1) % strings.length);
        }
      } else {
        if (charIndex < strings[index].length) {
          setText((prev) => prev + strings[index][charIndex]);
          setCharIndex((prev) => prev + 1);
        } else {
          if (loop || index < strings.length - 1) {
            setTimeout(() => setIsDeleting(true), backDelay);
          }
        }
      }
    }, isDeleting ? backSpeed : typeSpeed);

    return () => clearTimeout(timeout);
  }, [text, charIndex, isDeleting, index, strings, typeSpeed, backSpeed, backDelay, loop]);

  const styles = {
    backgroundImage: `url(${imageError})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    minHeight: "100vh",
  };

  return (
    <body style={styles} className="error-page" >
      <div className="content">
        <div className="browser-bar">
          <span className="close button"></span>
          <span className="min button"></span>
          <span className="max button"></span>
        </div>
        <div className="text">
          {text}
          {showCursor && <span className="typed-cursor">{cursorChar}</span>}
        </div>
        <Button onClick={() => navigate('/dashboard')} variant="contained" size="large"> برگشت به خانه</Button>
      </div>
    </body>
  );
};

export { Error404 };
